<template>
  <div v-if="loaded" class="rounded-lg bg-white border border-gray-200 max-w-4xl mx-auto bg-quickstart-purple">
    <div class="p-12 text-center">
      <aside class="text-5xl">👋</aside>
      <h1 class="text-2xl font-bold text-white">Welcome to your Humaniz dashboard!</h1>
      <p class="text-white/80">Congrats on getting started with Humaniz! Let's get you setup for success.</p>
    </div>

    <div class="px-12 pb-12">
      <Card v-for="step in incompleteSteps" :key="step.key" class="gap-1 mb-1">
        <CardHeader>
          <div class="lg:w-4/5">
            <CardTitle>{{ step.title }}</CardTitle>
            <CardDescription>{{ step.description }}</CardDescription>
          </div>
          <CardAction>
            <router-link :to="step.link">
              <TButton :disabled="isButtonDisabled(step)">{{ step.buttonText }}</TButton>
            </router-link>
          </CardAction>
        </CardHeader>
      </Card>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref } from 'vue';
import { Card, CardAction, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { initialQuickstartSteps, type QuickstartStep } from './quickstartSteps';

const steps = reactive<QuickstartStep[]>(initialQuickstartSteps);
const loaded = ref(false);

const emit = defineEmits(['handle-setup-complete']);

const incompleteSteps = computed((): QuickstartStep[] => {
  return steps.filter(step => !step.completed);
});

const incompleteStepKeys = computed(() => {
  return incompleteSteps.value.map(step => step.key);
});

const isButtonDisabled = (step: QuickstartStep) => {
  if (!step.disabled) return false;

  // users_setup is optional
  // all other steps are required
  if (incompleteStepKeys.value.includes('jobs_setup')) return true;
  if (incompleteStepKeys.value.includes('phone_number_setup')) return true;
  if (incompleteStepKeys.value.includes('recruiting_social_ads_setup')) return true;

  return false;
};

const syncCompletedSteps = async () => {
  const res = await fetch(`/api/setup/1`);
  const data = await res.json();

  for (let setupKey of Object.keys(data.steps)) {
    for (let step of steps) {
      if (setupKey === step.key) {
        step.completed = data.steps[setupKey];
      }
    }
  }
};

onMounted(async () => {
  await syncCompletedSteps();

  if (incompleteSteps.value.length === 0) {
    emit('handle-setup-complete');
  }

  loaded.value = true;
});
</script>
